module.exports = __webpack_public_path__ + "img/8ab5f8d1e158e827317efd6b26003c45.png";